import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M17.782 2H4.777a.792.792 0 0 0-.573.24.65.65 0 0 0-.204.482V20h1.309v-8.178h12.473c.218 0 .273-.107.163-.32L15.328 6.89l2.617-4.61c.055-.054.055-.107 0-.16-.027-.08-.081-.121-.163-.121Zm-1.84 8.539H12.71V8.134h-2.454v2.405H7.762V8.134H5.31V5.648h2.453V3.243h2.495v2.405h2.454V3.243h3.23l-1.39 2.405h-1.84v2.446h1.84l1.39 2.445Zm-8.18-4.89h2.495v2.445H7.762V5.648Z" />
  </svg>
);
